import Page from '../Page';
import {useEffect, useState} from 'preact/hooks';
import {useLocation} from 'preact-iso';
import {countConfiguredProducts} from '../../../../shared/models/product-configurator';
import {listAutoSortCollections} from '../../../../shared/models/collection-sort';

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

// Counts are a convenience; a failed count hides its line instead of blocking the card.
function useCount(load) {
  const [count, setCount] = useState(null);
  useEffect(() => { load().then(setCount).catch(() => setCount(undefined)); }, []);
  return count;
}

function AreaCard({heading, description, summary, href, action}) {
  const location = useLocation();
  return <s-section heading={heading}>
    <s-stack gap="base">
      <s-paragraph>{description}</s-paragraph>
      {summary === null ? <s-spinner size="base" accessibilityLabel={`Loading ${heading.toLowerCase()}`} />
        : summary && <s-text color="subdued">{summary}</s-text>}
      <s-stack direction="inline">
        <s-button href={href} onClick={(event) => { event.preventDefault(); location.route(href); }}>{action}</s-button>
      </s-stack>
    </s-stack>
  </s-section>;
}

export default function HomePage() {
  const products = useCount(countConfiguredProducts);
  const collections = useCount(() => listAutoSortCollections().then((list) => list.length));
  return (
    <Page heading="EVP Configurator">
      <s-query-container>
        <s-grid gridTemplateColumns="@container (inline-size > 640px) 1fr 1fr, 1fr" gap="base">
          <AreaCard heading="Products" href="/products" action="Manage products"
            description="Configure product options, requirements, add-ons, and terms."
            summary={products == null ? products : plural(products, 'configured product', 'configured products')} />
          <AreaCard heading="Collections" href="/collections" action="Manage collections"
            description="Configure how collections behave. Currently available: product sorting."
            summary={collections == null ? collections : plural(collections, 'collection sorted automatically', 'collections sorted automatically')} />
        </s-grid>
      </s-query-container>
    </Page>
  );
}
